/**
 * Dialogue Lines Configuration
 * Provides the base URL for fetching episode dialogue-line audio files.
 * In production, files are served from the GCS bucket.
 * In local development, the Vite dev server plugin serves them from local-gcp-environment/.
 */

import { getCurrentEnvironment } from '../../config/nakama.config';

const DIALOGUE_LINES_BASE_URLS: Record<string, string> = {
  local: '/dialogue-lines',
  develop: 'https://storage.googleapis.com/ponder-flight-game-extra-assets-develop/dialogue-lines',
  staging: 'https://storage.googleapis.com/ponder-flight-game-extra-assets-staging/dialogue-lines',
  production: 'https://storage.googleapis.com/ponder-flight-game-extra-assets-production/dialogue-lines',
};

/**
 * Returns the base URL for dialogue-line audio assets for the current environment.
 */
export function getDialogueLinesBaseUrl(): string {
  const env = getCurrentEnvironment();
  return DIALOGUE_LINES_BASE_URLS[env] ?? DIALOGUE_LINES_BASE_URLS.production;
}
